import { render, staticRenderFns } from "./Sitting_pretty.vue?vue&type=template&id=ad26f5c4&"
import script from "./Sitting_pretty.vue?vue&type=script&lang=js&"
export * from "./Sitting_pretty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports